// This module is in every brand's template pack, i.e. on every page of the
// site, so a static `import "@fancyapps/fancybox"` here put fancybox in
// every bundle no matter what -- which is why jQuery.fancybox was still
// defined on rebuilt pages even after setup.js stopped importing it. The
// fallback below is the only thing that needs it, and only when the
// Tailwind helper is missing, so it loads there instead.
import jsCookie from "js-cookie";

import { loadLegacyPlugins } from "../legacy_plugins";

declare const window: any;

$(window).on("load", (): void => {
  if ($("#cookie_message").length > 0) {
    if (!jsCookie.get("cookie_message")) {
      $("#cookie_message").show();
      $("#cookie_message_readmore").on("click", (): void => {
        // Rebuilt Tailwind pages (.tw-page) get the same Tailwind dialog
        // as the rest of the site-wide fancybox replacement (see
        // step2_seating_fix memory) -- window.showAlertMessageDialog is
        // setup.js's own helper for exactly this "wrap already-rendered
        // content in a dialog shell" case, reused here rather than
        // duplicating it. This template-level pack (loaded by the layout
        // itself) can't assume load order against setup.js's own
        // page-level pack, so this falls back to fancybox if that
        // helper isn't defined for any reason.
        if (document.querySelector(".tw-page") && window.showAlertMessageDialog) {
          window.showAlertMessageDialog(document.getElementById("cookie_message_popup"));
        } else {
          loadLegacyPlugins().then((): void => {
            $.fancybox.open($("#cookie_message_popup"), { autoSize: true });
          });
        }
        jsCookie.set("cookie_message", "true", { expires: 7 });
        $("#cookie_message").hide();
      });
    }
  }
});
